<template>
  <div class="wrapper">
    <el-dialog title="打款记录" :visible.sync="dialogVisible" width="1000px" :before-close="close">
      <vxe-toolbar
        id="toolbarId_ca2"
        :custom="{ storage: true }"
        :refresh="{ query: RefreshList }"
        export
      >
        <template v-slot:buttons>
          <el-button type="primary" @click="funcFilter()">查询</el-button>
          <el-button @click="funcExport()">导出</el-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        class="mytable-style"
        highlight-hover-row
        highlight-current-row
        row-id="id"
        height="500"
        :data="tableData"
        :loading="loading"
        :sort-config="{ remote: true }"
        export-config
        show-overflow
        align="center"
      >
        <vxe-table-column>
          <vxe-table-column field="orderNo" title="支付流水" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.orderNo" placeholder="请输入支付流水" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="amount" title="金额(元)" min-width="180" sortable />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input v-model="listQuery.amountStart" type="number" placeholder="下限" clearable />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input v-model="listQuery.amountEnd" type="number" placeholder="上限" clearable />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="platformCompanyName" title="平台开户企业" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.platformCompanyName" placeholder="请输入平台开户企业" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="platformBank" title="平台付款银行" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.platformBank" placeholder="请输入平台付款银行" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="platformAccount" title="平台银行账号" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.platformAccount" placeholder="请输入平台银行账号" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="payeeName" title="收款方" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.payeeName" placeholder="请输入收款方" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="payeePhone" title="收款方联系电话" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.payeePhone" placeholder="请输入收款方联系电话" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="bankCode"
            title="收款方银行"
            min-width="180"
            :formatter="formatBank"
            sortable
          />
          <template v-slot:header>
            <el-select v-model="listQuery.bankCode" placeholder="请选择" filterable clearable>
              <el-option
                v-for="item in bankList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="payeeAccount" title="收款方银行账户" min-width="180" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.payeeAccount" placeholder="请输入收款方银行账户" clearable />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="callbackTime" title="到账时间" min-width="240" sortable />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.callbackTimeRange"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'callbackTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="gmtCreated" title="创建时间" min-width="240" sortable />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="isPayAdvance" title="是否预付" min-width="130" sortable>
            <template v-slot="{ row }">
              <div>
                <span v-if="row.isPayAdvance == '0'">否</span>
                <span v-if="row.isPayAdvance == '1'">是</span>
              </div>
            </template>
          </vxe-table-column>
          <template v-slot:header>
            <el-select v-model="listQuery.isPayAdvance" placeholder="请选择" clearable>
              <el-option
                v-for="item in parentData.isPayAdvanceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="payReceiptImg" title="支付凭证" min-width="150">
            <template v-slot="{ row }">
              <div v-if="row.payType == '5' ||row.payType == '4'||row.payType == '10'||row.payType == '11'">
                <el-button @click="lookReceipt(row)">查看电子回单</el-button>
              </div>
              <div v-else>
                <el-image
                  style="width:100%"
                  :src="row.payReceiptImg"
                  :preview-src-list="[row.payReceiptImg]"
                >
                  <div slot="error" class="image-slot">获取失败</div>
                </el-image>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payStatus"
            title="支付状态"
            min-width="130"
            :formatter="({ cellValue }) => formatterField({ cellValue }, 'payStatus')"
            sortable
          />
          <template v-slot:header>
            <el-select v-model="listQuery.payStatus" placeholder="请选择" clearable>
              <el-option
                v-for="item in parentData.payStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="payType"
            title="支付类型"
            min-width="130"
            :formatter="({ cellValue }) => formatterField({ cellValue }, 'payType')"
            sortable
          />
          <template v-slot:header>
            <el-select v-model="listQuery.payType" placeholder="请选择" clearable>
              <el-option
                v-for="item in parentData.payTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column field="remark" title="备注" min-width="130" sortable />
          <template v-slot:header>
            <el-input v-model="listQuery.remark" placeholder="请输入备注" clearable />
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="taxAmount" title="含税金额" min-width="130" sortable /> -->
      </vxe-table>
      <vxe-pager
        :loading="loading"
        :current-page.sync="listQuery.pageNum"
        :page-size.sync="listQuery.pageSize"
        :page-sizes="Pagingconf"
        :total="listQuery.total"
        :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
        @page-change="handlePageChange"
      />
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import { listForFundFlow } from "@/api/transport"
import { electronicReceipt } from "@/api/InternetBanking"
import { getListDict } from '@/api/commonApi'
export default {
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/remitDefinite/exportFundFlowRemitDefiniteList",//导出接口
        name: '打款记录'
      },
      dialogVisible: false,
      loading: false,
      tableData: [],
      listQuery: {
        callbackTimeRange: '',
        gmtCreatedRange: '',
        addressType: 0,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      code: '',
      bankList: []
    }
  },
  created() {
    // 获取数据字典： 银行
    getListDict({ types: 'bank' }).then((response) => {
      this.bankList = response.data.filter((item) => item.type === 'bank')[0][
        'dictList'
      ]
    })
    this.parentData.isPayAdvanceOptions = [
      { label: '否', value: 0 },
      { label: '是', value: 1 }
    ]
    this.parentData.payStatusOptions = [
      { label: '处理中', value: 0 },
      { label: '支付成功', value: 1 },
      { label: '支付失败', value: 2 }
    ]
    this.parentData.payTypeOptions = [
      {label: '废弃', value: 0},//新增
      {label: '油点支付', value: 1},
      {label: '加油', value: 2},
      {label: '转账支付', value: 3},
      {label: '余额支付', value: 4},
      {label: '合并支付', value: 5},
      {label: '车队分账', value: 6},//新增
      {label: '凭证分账', value: 9},//新增
      {label: '银行支付', value: 10},
      {label: '在线支付', value: 11}//新增
    ]
  },
  methods: {
    show(c) {
      this.tableData = []
      this.dialogVisible = true
      this.code = c
      this.listQuery.orderDetailCode = c
      this.initQuery = JSON.stringify(this.listQuery)
      this.findList()
    },
    // 获取/查询 列表
    async findList() {
      this.loading = true;
      let response = await listForFundFlow(this.listQuery)
      this.loading = false;
      this.tableData = response.data.records || [];
      if (this.tableData.length !== 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          for (let key in this.tableData[i]) {
            if (this.tableData[i][key] === '') {
              this.tableData[i][key] = '--'
            }
          }
        }
      }
      this.listQuery.total = response.data.total;
    },
    lookReceipt(row) {
      electronicReceipt({ code: row.code }).then(res => {
        let url = res.data
        if (url) {
          window.open(url, '_blank');
        } else {
          return this.$message({ message: "暂无回单", type: "warning" });
        }

      }).catch(res => {

      })
    },
    submit() {
      this.$emit('onSuccess')
      this.dialogVisible = false
    },
    // cancel(){
    //   this.$emit('onCancel')
    //   this.dialogVisible = false
    // },
    onSearch() {
      this.findList()
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        (item) => item.value === cellValue
      )
      return item ? item.label : ''
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 关闭
    close() {
      this.dialogVisible = false
    },
    formatBank({ cellValue }) {
      const item = this.bankList.find((item) => item.code === cellValue)
      return item ? item.name : ''
    },
  }
}
</script>
<style scoped lang='scss'>
</style>
